var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInclusion = function SvgInclusion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24 6.247 12.553 5.2L41.753 24l-5.2 12.553L24 41.753l-12.553-5.2L6.247 24l5.2-12.553zM24 3 9.151 9.151 3 24l6.151 14.85L24 45l14.849-6.15L45 24 38.849 9.151z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.154,
    cy: 17.154,
    r: 3.051
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 34.842,
    r: 1.958
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.842,
    cy: 24,
    r: 1.958
  })));
};
export default SvgInclusion;